import React from "react";
import {useField} from "formik";

interface CheckboxPropsI extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
    label: string,
    name: string,
}

const Checkbox: React.FC<CheckboxPropsI> = ({name, id, label, ...props}) => {

    const [field] = useField(name);

    return (
        <label
            className="blj-store-locator-checkbox"
            htmlFor={id}
        >
            <input
                className="blj-store-locator-checkbox__input"
                type="checkbox"
                id={id}
                {...field}
                {...props}
            />
            <span className="blj-store-locator-checkbox__checkmark"></span>
            <span className="blj-store-locator-checkbox__label">
                {label}
            </span>
        </label>
    );
}

export default Checkbox;